var map = {
	"./": 483,
	"./OldUi": 2651,
	"./OldUi.js": 2651,
	"./SpireonNew": 2652,
	"./SpireonNew.js": 2652,
	"./SpireonOld": 2653,
	"./SpireonOld.js": 2653,
	"./index": 483,
	"./index.js": 483,
	"./style": 372,
	"./style.js": 372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4139;